import { Navigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { isSignedIn, user, isLoaded } = useUser();

  if (!isLoaded) return <div>Loading...</div>;
  if (!isSignedIn) return <Navigate to="/login" />;

  if (requiredRole) {
    const role = user?.publicMetadata?.role || 'member';
    // Allow if role matches required OR if role is super_admin (which can access everything)
    const hasAccess = role === requiredRole || role === 'super_admin';
    if (!hasAccess) {
      return <Navigate to="/feed" />;
    }
  }

  return children;
};

export default ProtectedRoute;